export const companiesConfig = {
	pageCount: 20,
};
